import {
	optionsFrequency,
	optionsFrequencyCore,
	optionsWhen,
	optionsWhenCore,
	optionsWho,
	optionsWhoCore,
	optionsMsgType,
	optionsDistributionType,
} from '@/pages/notifications/helper';
import React from 'react';

export const schemas = {
	thermal: (data, options, callbacks) => {
		return [
			{
				name: 'messageType',
				label: 'Message Type',
				placeholder: 'SMS / Email',
				tooltip:
					'Select to send this message as SMS or email (SMS will incur a small charge).',
				type: 'select',
				initialValue: data && data.messageType,
				options: optionsMsgType,
				onChange: (value, setter, values, setFields) => {
					const error =
						value === 'sms' &&
						values.alertTemplate &&
						values.alertTemplate.length > 160;
					setFields({
						alertTemplate: {
							value: values.alertTemplate,
							errors: error ? 'true' : null,
						},
					});
					setter({ specificAddress: null });
				},
				rules: [
					{
						required: true,
						message: 'Please choose one',
					},
				],
			},
			{
				name: 'alertName',
				label: 'Name of Notification',
				tooltip:
					'Give this notification a name so you can find it again, it won’t appear anywhere in the message.',
				initialValue: data && data.alertName,
				help: value => (value ? value.length + '/64' : 0 + '/64'),
				rules: [
					{
						required: true,
						max: 64,
					},
				],
				inputProps: {
					maxLength: 64,
				},
			},
			{
				name: 'subjectTemplate',
				label: 'Subject',
				tooltip: 'Enter your email subject here.',
				initialValue: data && data.subjectTemplate,
				help: value => (value ? value.length + '/64' : 0 + '/64'),
				hide: values =>
					values.messageType !== 'email' || !values.messageType,
				rules: [
					{
						required: true,
						max: 64,
					},
				],
				inputProps: {
					maxLength: 64,
				},
			},
			{
				name: 'alertTemplate',
				label: 'Message',
				tooltip:
					'Enter your message text here; you can include the {name} placeholder, and use http:// links to webpages.',
				type: 'textarea',
				initialValue: data && data.alertTemplate,
				help: value => (value ? value.length + '/160' : 0 + '/160'),
				hide: values =>
					values.messageType !== 'sms' || !values.messageType,
				rules: [
					{
						required: true,
						max: 160,
					},
				],
				inputProps: {
					maxLength: 160,
					autosize: { minRows: 4, maxRows: 6 },
					placeholder: 'Message',
				},
			},
			{
				name: 'alertTemplate',
				label: 'Message',
				tooltip:
					'Enter your message text here; you can include the {name} placeholder, and use http:// links to webpages.',
				type: 'textarea',
				initialValue: data && data.alertTemplate,
				hide: values =>
					values.messageType !== 'email' || !values.messageType,
				help: value => (value ? value.length + '/5000' : 0 + '/5000'),
				rules: [
					{
						required: true,
						max: 5000,
					},
				],
				inputProps: {
					maxLength: 5000,
					autosize: { minRows: 4, maxRows: 6 },
					placeholder: 'Message',
				},
			},
			{
				name: 'actionType',
				label: 'When to send',
				tooltip: 'Select what event will trigger this notification.',
				placeholder: 'When',
				initialValue: data && data.actionType,
				type: 'select',
				options: optionsWhenCore,
				onChange: (value, setter) =>
					value === 'evac-end' && setter({ frequency: 0 }),
				rules: [
					{
						required: true,
						message: 'Please choose one',
					},
				],
			},
			{
				name: 'targetType',
				label: 'Who will trigger',
				tooltip: 'Select contacts that will trigger this notification.',
				placeholder: 'Who',
				initialValue: data && data.targetType,
				type: 'select',
				options: optionsWhoCore,
				rules: [
					{
						required: true,
						message: 'Please choose one',
					},
				],
			},
			{
				name: 'siteId',
				label: 'Site',
				tooltip: 'Select which site this notification applies to.',
				placeholder: 'Site',
				initialValue: data && data.siteId,
				hide: values =>
					values.targetType === 'all' || !values.targetType,
				type: 'select',
				options: options.siteId,
				optionValue: 'siteId',
				optionKey: 'siteId',
				optionLabel: 'address',
				onChange: (value, setter) => {
					callbacks && callbacks.siteId(value);
				},
				rules: [
					{
						required: true,
						message: 'Please choose one',
					},
				],
			},
			{
				name: 'zoneIds',
				label: 'Zones',
				tooltip:
					'Select which zone(s) at this site triggers this notification.',
				initialValue: data && data.zoneIds,
				hide: values =>
					values.targetType === 'all' ||
					!values.targetType ||
					!values.siteId,
				type: 'checkbox-group',
				options: options.zoneIds,
				optionValue: 'zoneId',
				optionKey: 'zoneId',
				optionLabel: 'name',
				emptyMsg: 'You need to choose Site',
				rules: [
					{
						required: true,
						message: 'Please choose at least one zone',
					},
				],
			},
			{
				name: 'frequency',
				label: 'Frequency',
				tooltip:
					'Select the minimum time before a message is sent again to the same contact.',
				placeholder: 'frequency',
				initialValue: data && data.frequency,
				type: 'select',
				options: optionsFrequencyCore,
				optionsDisabled: (option, values) =>
					values.actionType === 'evac-end' && option.value !== 0,
				rules: [
					{
						required: true,
						message: 'Please choose one',
					},
				],
			},
			{
				name: 'specificAddress',
				label: 'Recipient override',
				tooltip:
					'Enter email address if you want this to go to a specific recipient — leave blank if the message should go to directly to the contact.',
				initialValue: data && data.specificAddress,
				placeholder: 'Email',
				hide: values =>
					values.messageType !== 'email' || !values.messageType,
				rules: [
					{
						type: 'email',
						message: 'it is not a valid email',
					},
				],
			},
			{
				name: 'specificAddress',
				label: 'Recipient override',
				tooltip:
					'Enter phone number if you want this to go to a specific recipient — leave blank if the message should go to directly to the contact.',
				initialValue: data && data.specificAddress,
				placeholder: 'Phone',
				hide: values =>
					values.messageType !== 'sms' || !values.messageType,
				rules: [
					{
						whitespace: true,
						pattern: new RegExp(/^[\+]?[0-9]*$/gm),
						message: 'Only numbers are allowed',
					},
				],
			},
			{
				name: 'distributionType',
				label: 'Contacts this applies to',
				tooltip: 'Select the contacts this rule applies to.',
				placeholder: 'all / specific contacts',
				initialValue: data && data.distributionType,
				type: 'select',
				options: optionsDistributionType,
				rules: [
					{
						required: true,
						message: 'Please choose one',
					},
				],
			},
			{
				name: 'clientReferences',
				label: 'Selected contacts',
				tooltip:
					'Select individual contacts that this rule applies to.',
				placeholder: 'Contact',
				initialValue:
					data && data.clientReferences ? data.clientReferences : [],
				type: 'transfer',
				titles: ['Remaining', 'Selected'],
				hide: values =>
					values.distributionType === 'all' ||
					!values.distributionType,
				options: options.clientReferences,
				rowKey: 'clientReference',
				renderOption: record =>
					`${record.clientReference} - ${record.name}`,
				rules: [
					{
						required: true,
						message: 'Please choose at least one contact',
					},
				],
			},
		];
	},
	evacuation: (data, options, callbacks) => {
		return [
			{
				name: 'messageType',
				label: 'Message Type',
				tooltip:
					'Select to send this message as SMS or email (SMS will incur a small charge).',
				placeholder: 'SMS / Email',
				initialValue: data && data.messageType,
				type: 'select',
				options: optionsMsgType,
				onChange: (value, setter, values, setFields) => {
					const error =
						value === 'sms' &&
						values.alertTemplate &&
						values.alertTemplate.length > 160;
					setFields({
						alertTemplate: {
							value: values.alertTemplate,
							errors: error ? 'true' : null,
						},
					});
					setter({ specificAddress: null });
				},
				rules: [
					{
						required: true,
						message: 'Please choose one',
					},
				],
			},
			{
				name: 'alertName',
				label: 'Name of Notification',
				tooltip:
					'Give this notification a name so you can find it again, it won’t appear anywhere in the message.',
				initialValue: data && data.alertName,
				help: value => (value ? value.length + '/64' : 0 + '/64'),
				rules: [
					{
						required: true,
						max: 64,
					},
				],
				inputProps: {
					maxLength: 64,
				},
			},
			{
				name: 'subjectTemplate',
				label: 'Subject',
				tooltip: 'Enter your email subject here.',
				initialValue: data && data.subjectTemplate,
				help: value => (value ? value.length + '/64' : 0 + '/64'),
				hide: values =>
					values.messageType !== 'email' || !values.messageType,
				rules: [
					{
						required: true,
						max: 64,
					},
				],
				inputProps: {
					maxLength: 64,
				},
			},
			{
				name: 'alertTemplate',
				label: 'Message',
				tooltip:
					'Enter your message text here; you can include the {name} placeholder, and use http:// links to webpages.',
				type: 'textarea',
				initialValue: data && data.alertTemplate,
				help: value => (value ? value.length + '/160' : 0 + '/160'),
				hide: values =>
					values.messageType !== 'sms' || !values.messageType,
				rules: [
					{
						required: true,
						max: 160,
					},
				],
				inputProps: {
					maxLength: 160,
					autosize: { minRows: 4, maxRows: 6 },
					placeholder: 'Message',
				},
			},
			{
				name: 'alertTemplate',
				label: 'Message',
				tooltip:
					'Enter your message text here; you can include the {name} placeholder, and use http:// links to webpages.',
				type: 'textarea',
				initialValue: data && data.alertTemplate,
				hide: values =>
					values.messageType !== 'email' || !values.messageType,
				help: value => (value ? value.length + '/5000' : 0 + '/5000'),
				rules: [
					{
						required: true,
						max: 5000,
					},
				],
				inputProps: {
					maxLength: 5000,
					autosize: { minRows: 4, maxRows: 6 },
					placeholder: 'Message',
				},
			},
			{
				name: 'actionType',
				label: 'When to send',
				tooltip: 'Select what event will trigger this notification.',
				placeholder: 'When',
				initialValue: data && data.actionType,
				type: 'select',
				options: optionsWhen,
				onChange: (value, setter) =>
					value === 'evac-end' && setter({ frequency: 0 }),
				rules: [
					{
						required: true,
						message: 'Please choose one',
					},
				],
			},
			{
				name: 'targetType',
				label: 'Who will trigger',
				tooltip: 'Select contacts that will trigger this notification.',
				placeholder: 'Who',
				initialValue: data && data.targetType,
				type: 'select',
				options: optionsWho,
				rules: [
					{
						required: true,
						message: 'Please choose one',
					},
				],
			},
			{
				name: 'siteId',
				label: 'Site',
				tooltip: 'Select which site this notification applies to.',
				placeholder: 'Site',
				initialValue: data && data.siteId,
				hide: values =>
					values.targetType === 'all' || !values.targetType,
				type: 'select',
				options: options.siteId,
				optionValue: 'siteId',
				optionKey: 'siteId',
				optionLabel: 'address',
				onChange: (value, setter) => {
					callbacks && callbacks.siteId(value);
				},
				rules: [
					{
						required: true,
						message: 'Please choose one',
					},
				],
			},
			{
				name: 'zoneIds',
				label: 'Zones',
				tooltip:
					'Select which zone(s) at this site triggers this notification.',
				initialValue: data && data.zoneIds,
				hide: values =>
					values.targetType === 'all' ||
					!values.targetType ||
					!values.siteId,
				type: 'checkbox-group',
				options: options.zoneIds,
				optionValue: 'zoneId',
				optionKey: 'zoneId',
				optionLabel: 'name',
				emptyMsg: 'You need to choose Site',
				rules: [
					{
						required: true,
						message: 'Please choose at least one zone',
					},
				],
			},
			{
				name: 'frequency',
				label: 'Frequency',
				tooltip:
					'Select the minimum time before a message is sent again to the same contact.',
				placeholder: 'frequency',
				initialValue: data && data.frequency,
				type: 'select',
				options: optionsFrequency,
				optionsDisabled: (option, values) =>
					values.actionType === 'evac-end' && option.value !== 0,
				rules: [
					{
						required: true,
						message: 'Please choose one',
					},
				],
			},
			{
				name: 'specificAddress',
				label: 'Recipient override',
				tooltip:
					'Enter email address if you want this to go to a specific recipient — leave blank if the message should go to directly to the contact.',
				initialValue: data && data.specificAddress,
				placeholder: 'Email',
				hide: values =>
					values.messageType !== 'email' || !values.messageType,
				rules: [
					{
						type: 'email',
						message: 'it is not a valid email',
					},
				],
			},
			{
				name: 'specificAddress',
				label: 'Recipient override',
				tooltip:
					'Enter phone number if you want this to go to a specific recipient — leave blank if the message should go to directly to the contact.',
				initialValue: data && data.specificAddress,
				placeholder: 'Phone',
				hide: values =>
					values.messageType !== 'sms' || !values.messageType,
				rules: [
					{
						whitespace: true,
						pattern: new RegExp(/^[\+]?[0-9]*$/gm),
						message: 'Only numbers are allowed',
					},
				],
			},
			{
				name: 'distributionType',
				label: 'Contacts this applies to',
				tooltip: 'Select the contacts this rule applies to.',
				placeholder: 'all / specific contacts',
				initialValue: data && data.distributionType,
				type: 'select',
				options: optionsDistributionType,
				rules: [
					{
						required: true,
						message: 'Please choose one',
					},
				],
			},
			{
				name: 'clientReferences',
				label: 'Selected contacts',
				tooltip:
					'Select individual contacts that this rule applies to.',
				placeholder: 'Contact',
				initialValue:
					data && data.clientReferences ? data.clientReferences : [],
				type: 'transfer',
				titles: ['Remaining', 'Selected'],
				hide: values =>
					values.distributionType === 'all' ||
					!values.distributionType,
				options: options.clientReferences,
				rowKey: 'clientReference',
				renderOption: record =>
					`${record.clientReference} - ${record.name}`,
				rules: [
					{
						required: true,
						message: 'Please choose at least one contact',
					},
				],
			},
		];
	},
	core: (data, options, callbacks, type) => {
		return [
			{
				name: 'messageType',
				label: 'Message Type',
				placeholder: 'SMS / Email',
				tooltip:
					'Select to send this message as SMS or email (SMS will incur a small charge).',
				initialValue: data && data.messageType,
				type: 'select',
				options: optionsMsgType,
				onChange: (value, setter, values, setFields) => {
					const error =
						value === 'sms' &&
						values.alertTemplate &&
						values.alertTemplate.length > 160;
					setFields({
						alertTemplate: {
							value: values.alertTemplate,
							errors: error ? 'true' : null,
						},
					});
				},
				rules: [
					{
						required: true,
						message: 'Please choose one',
					},
				],
			},
			{
				name: 'alertName',
				label: 'Name of Notification',
				tooltip:
					'Give this notification a name so you can find it again, it won’t appear anywhere in the message.',
				initialValue: data && data.alertName,
				help: value => (value ? value.length + '/64' : 0 + '/64'),
				rules: [
					{
						required: true,
						max: 64,
					},
				],
				inputProps: {
					maxLength: 64,
				},
			},
			{
				name: 'subjectTemplate',
				label: 'Subject',
				tooltip: 'Enter your email subject here.',
				initialValue: data && data.subjectTemplate,
				help: value => (value ? value.length + '/64' : 0 + '/64'),
				hide: values =>
					values.messageType !== 'email' || !values.messageType,
				rules: [
					{
						required: true,
						max: 64,
					},
				],
				inputProps: {
					maxLength: 64,
				},
			},
			{
				name: 'alertTemplate',
				label: 'Message',
				tooltip:
					'Enter your message text here; you can include the {name} placeholder, and use http:// links to webpages.',
				type: 'textarea',
				initialValue: data && data.alertTemplate,
				help: value => (value ? value.length + '/160' : 0 + '/160'),
				hide: values =>
					values.messageType !== 'sms' || !values.messageType,
				rules: [
					{
						required: true,
						max: 160,
					},
				],
				inputProps: {
					maxLength: 160,
					autosize: { minRows: 4, maxRows: 6 },
					placeholder: 'Message',
				},
			},
			{
				name: 'alertTemplate',
				label: 'Message',
				tooltip:
					'Enter your message text here; you can include the {name} placeholder, and use http:// links to webpages.',
				type: 'textarea',
				initialValue: data && data.alertTemplate,
				hide: values =>
					values.messageType !== 'email' || !values.messageType,
				help: value => (value ? value.length + '/5000' : 0 + '/5000'),
				rules: [
					{
						required: true,
						max: 5000,
					},
				],
				inputProps: {
					maxLength: 5000,
					autosize: { minRows: 4, maxRows: 6 },
					placeholder: 'Message',
				},
			},
			{
				name: 'actionType',
				label: 'When to send',
				tooltip: 'Select what event will trigger this notification.',
				placeholder: 'When',
				initialValue: data && data.actionType,
				type: 'select',
				options: optionsWhenCore,
				onChange: (value, setter) =>
					value === 'evac-end' && setter({ frequency: 0 }),
				rules: [
					{
						required: true,
						message: 'Please choose one',
					},
				],
			},
			{
				name: 'targetType',
				label: 'Who will trigger',
				tooltip: 'Select contacts that will trigger this notification.',
				placeholder: 'Who',
				initialValue: data && data.targetType,
				type: 'select',
				options: optionsWhoCore,
				rules: [
					{
						required: true,
						message: 'Please choose one',
					},
				],
			},
			{
				name: 'siteId',
				label: 'Site',
				tooltip: 'Select which site this notification applies to.',
				placeholder: 'Site',
				initialValue: data && data.siteId,
				hide: values =>
					values.targetType === 'all' || !values.targetType,
				type: 'select',
				options: options.siteId,
				optionValue: 'siteId',
				optionKey: 'siteId',
				optionLabel: 'address',
				onChange: (value, setter) => {
					callbacks && callbacks.siteId(value);
				},
				rules: [
					{
						required: true,
						message: 'Please choose one',
					},
				],
			},
			{
				name: 'zoneIds',
				label: 'Zones',
				tooltip:
					'Select which zone(s) at this site triggers this notification.',
				initialValue: data && data.zoneIds,
				hide: values =>
					values.targetType === 'all' ||
					!values.targetType ||
					!values.siteId,
				type: 'checkbox-group',
				options: options.zoneIds,
				optionValue: 'zoneId',
				optionKey: 'zoneId',
				optionLabel: 'name',
				emptyMsg: 'You need to choose Site',
				rules: [
					{
						required: true,
						message: 'Please choose at least one zone',
					},
				],
			},
			{
				name: 'frequency',
				label: 'Frequency',
				tooltip:
					'Select the minimum time before a message is sent again to the same contact.',
				placeholder: 'frequency',
				initialValue: data && data.frequency,
				type: 'select',
				options: optionsFrequencyCore,
				optionsDisabled: (option, values) =>
					values.actionType === 'evac-end' && option.value !== 0,
				rules: [
					{
						required: true,
						message: 'Please choose one',
					},
				],
			},
			{
				name: 'specificAddress',
				label: 'Recipient override',
				tooltip:
					'Enter email addresses comma seperated if you want this to go to a specific recipient — leave blank if the message should go to directly to the contact.',
				initialValue: data && data.specificAddress,
				placeholder: 'Emails',
				hide: values =>
					values.messageType !== 'email' || !values.messageType
				// rules: [
				// 	{
				// 		type: 'email',
				// 		message: 'it is not a valid email',
				// 	},
				// ],
			},
			{
				name: 'specificAddress',
				label: 'Recipient override',
				tooltip:
					'Enter phone number if you want this to go to a specific recipient — leave blank if the message should go to directly to the contact.',
				initialValue: data && data.specificAddress,
				placeholder: 'Phone',
				hide: values =>
					values.messageType !== 'sms' || !values.messageType,
				rules: [
					{
						whitespace: true,
						pattern: new RegExp(/^[\+]?[0-9]*$/gm),
						message: 'Only numbers are allowed',
					},
				],
			},
			{
				name: 'distributionType',
				label: 'Contacts this applies to',
				tooltip: 'Select the contacts this rule applies to.',
				placeholder: 'This applies to',
				initialValue: data && data.distributionType,
				type: 'select',
				options: optionsDistributionType,
				rules: [
					{
						required: true,
						message: 'Please choose one',
					},
				],
			},
			{
				name: 'clientReferences',
				label: 'Selected contacts',
				tooltip:
					'Select individual contacts that this rule applies to.',
				placeholder: 'Contact',
				initialValue:
					data && data.clientReferences ? data.clientReferences : [],
				type: 'transfer',
				titles: ['Remaining', 'Selected'],
				hide: values =>
					values.distributionType === 'all' ||
					!values.distributionType,
				options: options.clientReferences,
				rowKey: 'clientReference',
				renderOption: record =>
					`${record.clientReference} - ${record.name}`,
				rules: [
					{
						required: true,
						message: 'Please choose at least one contact',
					},
				],
			},
		];
	},
};



// WEBPACK FOOTER //
// ./src/pages/notifications/notifications-form/schemas.js